import { baseQuery } from '../baseQuery';

export const postVoipPause = async (reason: string) => {
  const { data } = await baseQuery('voip-pause', {
    type: 'POST',
    body: {
      reason,
    },
  });

  return data;
};
